import { render, staticRenderFns } from "./goodeDetaile.vue?vue&type=template&id=8140f3cc&scoped=true&"
import script from "./goodeDetaile.vue?vue&type=script&lang=js&"
export * from "./goodeDetaile.vue?vue&type=script&lang=js&"
import style0 from "./goodeDetaile.vue?vue&type=style&index=0&id=8140f3cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8140f3cc",
  null
  
)

export default component.exports